<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ data.acps_name_foreign }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.status'
                  )
                }}
              </label>
              <div>
                <ts-loading-banner :loading="loadingPreData">
                  <treeselect
                    :options="
                      studentStatus.map(i => ({
                        id: i.status_id,
                        label: i.status
                      }))
                    "
                    :placeholder="$t('studentprofile.typeforsearch')"
                    v-model="model.status_id"
                  ></treeselect>
                </ts-loading-banner>
                <div class="validate" v-if="errors.has('status_id')">
                  {{ errors.first('status_id') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label
                class="col-form-label control-label"
                :class="model.status_id == 1 ? '' : 'required'"
              >
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.effectiveDate'
                  )
                }}
              </label>
              <div>
                <ts-date-picker-input v-model="model.status_effective_date" />
                <div
                  v-if="errors.has('status_effective_date')"
                  class="validate"
                >
                  {{ errors.first('status_effective_date') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label
                class="col-form-label control-label"
                :class="model.status_id == 1 ? '' : 'required'"
              >
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.reason'
                  )
                }}
              </label>
              <div>
                <textarea
                  v-model="model.status_reason"
                  rows="3"
                  class="form-control"
                  :class="{
                    'is-invalid': errors.has('status_reason')
                  }"
                ></textarea>
                <div
                  class="invalid-feedback"
                  v-if="errors.has('status_reason')"
                >
                  {{ errors.first('status_reason') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button
              class="btn-sm"
              @click.prevent="$emit('cancel')"
              :disabled="saving"
              >{{ $t('cancel') }}</ts-button
            >
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              :waiting="saving"
              @click.prevent="updateStatus"
              >{{ $t('submit') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  props: ['data'],
  name: 'student-profile-status-form',
  data() {
    return {
      model: {
        acps_id: '',
        student_id: '',
        status_id: '',
        status_effective_date: '',
        status_reason: '',
        deleteEnrollment: false
      },
      errors: new Errors(),
      saving: false,
      loadingPreData: false
    }
  },
  computed: {
    ...mapState('studentProfile', ['studentStatus'])
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    async fetchResourceBeforeCreate() {
      this.loadingPreData = true
      await this.$store
        .dispatch('studentProfile/getStudentStatus')
        .then(() => {
          this.setData()
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    setData() {
      this.model.acps_id = this.data.acps_id
      this.model.student_id = this.data.pivot.student_id
      this.model.status_id = this.data.pivot.status_id
      this.model.status_effective_date = this.data.pivot.status_effective_date
      this.model.status_reason = this.data.pivot.status_reason
    },
    async checkStatusBySubProgram() {
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'studentProfile/checkStatusBySubProgram',
          this.model
        )
        if (response.status == true) {
          // this.showConfirm()
          await this.update(true) 
          this.saving = false
          // this.$emit('close')
        }
        return response.status
      } catch (error) {
        this.saving = false
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
    },
    showConfirm() {
      const self = this
      this.$confirm({
        title: 'Do you want to delete from class enrollment?',
        okText: 'Yes',
        cancelText: 'No',
        onOk() {
          self.update(true)
        },
        onCancel() {
          self.update(false)
        },
        zIndex: 99999
      })
    },
    async updateStatus() {
      this.errors = new Errors()
      this.saving = true

      this.check = await this.checkStatusBySubProgram()

      if (this.check == false) {
        this.saving = false
        try {
          let response = await this.$store.dispatch(
            'studentProfile/updateStatusBySubProgram',
            this.model
          )
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('before-close')
          this.$emit('close')
        } catch (error) {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        }
        this.saving = false
      }
    },
    async update(value) {
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'studentProfile/updateStatusBySubProgram',
          { ...this.model, deleteEnrollment: value }
        )
        this.$toasted.success(response.message)
        this.$emit('before-close')
        this.$emit('close')
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$emit('before-close')
        this.$emit('close')
        this.$toasted.error(error.message)
      }
    }
  }
}
</script>
